import { render, staticRenderFns } from "./ParameterIdSelectbox.vue?vue&type=template&id=72a8f6b4&"
import script from "./ParameterIdSelectbox.vue?vue&type=script&lang=js&"
export * from "./ParameterIdSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports